module.exports = require('./multiply')



//////////////////
// WEBPACK FOOTER
// ./node_modules/gl-vec3/mul.js
// module id = OZ8K
// module chunks = 0